module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('h1', {
    staticClass: "f2 lh-copy pt3"
  }, [_vm._v("Claim #" + _vm._s(_vm.currentClaim.id) + " (" + _vm._s(_vm.status_text) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb3 pa4 bg-white shadow-card br2"
  }, [_c('div', {
    staticClass: "grid-half mt4"
  }, [_c('div', [_c('label', {
    staticClass: "f3 b db mb4",
    attrs: {
      "for": "date_submitted"
    }
  }, [_vm._v("Date Submitted:")]), _vm._v(" "), _c('span', {
    staticClass: "inter f4",
    attrs: {
      "id": "date_submitted"
    }
  }, [_vm._v(_vm._s(_vm.date_submitted))])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "f3 b db mb4",
    attrs: {
      "for": "date_of_loss"
    }
  }, [_vm._v("Date of Loss:")]), _vm._v(" "), _c('span', {
    staticClass: "inter f4",
    attrs: {
      "id": "date_of_loss"
    }
  }, [_vm._v(_vm._s(_vm.loss_date))])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-half mt5"
  }, [(!_vm.featureFlagMultiLossTypeActive) ? _c('div', [_c('label', {
    staticClass: "f3 b db mb4",
    attrs: {
      "for": "type_of_loss"
    }
  }, [_vm._v("Type of Loss:")]), _vm._v(" "), _c('span', {
    staticClass: "inter f4",
    attrs: {
      "id": "type_of_loss"
    }
  }, [_vm._v(_vm._s(_vm.currentClaim.loss_type) + " ")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "f3 b db mb4",
    attrs: {
      "for": "paypal_email"
    }
  }, [_vm._v("PayPal Email:")]), _vm._v(" "), _c('span', {
    staticClass: "inter f4",
    attrs: {
      "id": "paypal_email"
    }
  }, [_vm._v(_vm._s(_vm.currentClaim.paypal_email) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "grid mt5"
  }, [_c('div', [_c('label', {
    staticClass: "f3 b db mb4"
  }, [_vm._v("Items Affected:")]), _vm._v(" "), (_vm.currentClaim.devices.length > 0) ? _c('div', {
    staticClass: "grid-third mt4 mb6 mb4-ns"
  }, _vm._l((this.currentClaim.devices), function(device, index) {
    return _c('div', {
      key: index
    }, [_c('router-link', {
      staticClass: "no-underline black",
      attrs: {
        "to": ("/devices/" + (device.id))
      }
    }, [_c('ak-claim-device-tile', {
      attrs: {
        "brand": device.brand,
        "id": device.id,
        "model": device.model,
        "nickname": device.nickname ? device.nickname : ("Item " + (index+1)),
        "type": device.type,
        "serial": device.serial_number,
        "lossTypes": device.loss_types,
        "knownDamage": device.known_damage
      }
    })], 1)], 1)
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "grid mt5"
  }, [_c('div', [_c('label', {
    staticClass: "f3 b db mb4",
    attrs: {
      "for": "description_of_incident"
    }
  }, [_vm._v("Description of Incident:")]), _vm._v(" "), _c('span', {
    staticClass: "inter f4",
    attrs: {
      "id": "description_of_incident"
    }
  }, [_vm._v(_vm._s(_vm.currentClaim.description) + " ")])])]), _vm._v(" "), (!_vm.featureFlagMultiLossTypeActive) ? _c('div', {
    staticClass: "grid mt5"
  }, [_c('div', [_c('label', {
    staticClass: "f3 b db mb4",
    attrs: {
      "for": "previous_known_damage"
    }
  }, [_vm._v("Previous Known Damage:")]), _vm._v(" "), _c('span', {
    staticClass: "f4",
    attrs: {
      "id": "previous_known_damage"
    }
  }, [_vm._v(_vm._s(_vm.currentClaim.known_damage) + " ")])])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0216cab4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0216cab4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClaimPage.vue
// module id = 1681
// module chunks = 0